import React from 'react'

const ParticularsArrangement = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>The Particulars of any arrangement that exists for consultation with or representation by the member of public in relation to the formulation of its policy or implementation thereof</h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
      <p>Shareholders can raise issues concerning policies in the Annual General Meeting, which can relate to the policy of the Corporation. As on date, no such agreement exists.</p>
    </div>
    </div>
  )
}

export default ParticularsArrangement
